import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const darkMode = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1540,
    },
  },
  palette: {
    primary: {
      main: "#9c39bf",
      contrastText: "#ffffff",
    },
    background: {
      lighter: "#233554",
      light: "#3c313b", // for cards background
      main: "#201e25", // for main page
      dark: "#201e25", // for loading page
      contrastText: "#ffffff",
    },
    text: {
      lighter: "#e6f1ff",
      light: "#ccd6f6", // for titles
      main: "#a8b2d1", // for paragprahs in cards & left-right
      dark: "#8892b0", // for paragraphs
    },
    card: {
      main: "#28242a",
      highlighted: "#4e394e",
      error: "#4e394e",
    },
    mode: {
      dark: "black",
    },
  },
});

const lightMode = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1540,
    },
  },
  palette: {
    primary: {
      main: "#9c39bf",
      contrastText: "#000000",
    },
    background: {
      lighter: "#ffffff",
      light: "#f5f5f5",
      main: "#e0dae3",
      dark: "#e0e0e0",
      contrastText: "#000000",
    },
    text: {
      lighter: "#333333",
      //light: "#444444",
      light: "black",
      main: "#555555",
      //dark: "#666666",
      dark: "#444444",
    },
    card: {
      main: "#f4f0f6",
      highlighted: "#cdc0d2",
      error: "#b7a3c1",
    },
  },
});

const Theme = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const toggleTheme = () => setIsDarkMode(!isDarkMode);
  const theme = isDarkMode ? darkMode : lightMode;

  return (
    <ThemeProvider theme={theme}>
      {React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child, { toggleTheme, isDarkMode })
          : child
      )}
    </ThemeProvider>
  );
};

export default Theme;
